import { IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class PalletsDTO {
    static palletNo(palletCode: any, palletNo: any, pouchesPerRow: any) {
        throw new Error('Method not implemented.');
    }
    @ApiProperty()
    @IsOptional()
    palletId?: number;

    @ApiProperty()
    plantId: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Code not be empty" })
    palletCode: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    palletNo: string;
    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    assocRfId: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    isActive: boolean;


    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    createdUser: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Name should not be empty" })
    updatedUser: string;


}